<opac-button
  class="notifications-button"
  [matMenuTriggerFor]="notificationsMenu"
  [ariaLabel]="'tooltip.notifications' | translate" [opacTooltip]="'tooltip.notifications' | translate"
  (click)="getNotifications()"
  dataTestId="header-notifications-button"
>
  <opac-icon [badge]="isPendingNotifications" icon="notifications" slot="only-icon"></opac-icon>
</opac-button>

<mat-menu #notificationsMenu="matMenu" [xPosition]="'before'">
  <ng-template matMenuContent>
    <button *ngFor="let notification of notifications" class="notification-button" mat-menu-item (click)="handleNotification(notification)">
      <span class="notification-info">
        <h3 [innerHTML]="notification.subject"></h3>
        <span>{{ notification.dateCreated | date }}</span>
      </span>

      <p [innerHTML]="notification.content"></p>
    </button>
  </ng-template>

  <button mat-menu-item class="view-all-button" [routerLink]="['/user/notifications']">
    <opac-icon icon="notifications"></opac-icon>
    <span>{{ 'notifications.viewAll' | translate }}</span>
  </button>
</mat-menu>
